<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastDetail from '../../../../broadcasts/components/BroadcastDetail.vue'
import { BroadcastID } from '../../../../broadcasts/models/broadcast'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Employees',
                route: '/(app)/people/employees/',
            },
            {
                label: 'Availability',
                route: '/(app)/people/availability/',
            },
            {
                label: 'Broadcasts',
                route: '/(app)/people/broadcasts/',
            },
            {
                label: 'Time Off',
                route: '/(app)/people/time-off/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: BroadcastID
}>()
</script>

<template>
  <BroadcastDetail
    :id="id"
  />
</template>